/* eslint-disable camelcase */
/*
 * 企業側 ホットライン相談申し込み 面談更新
 */
import { apiCreate } from '@/actions/ApiBaseActions';
export const API_CREATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_CREATE = 'API_CREATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_CREATE';
export const API_CREATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_CANCEL = 'API_CREATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_CANCEL';
export const API_CREATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_REORDER = 'API_CREATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_REORDER';
/**
 * クライアント：ホットライン相談申し込み面談 受諾
 */
export const apiCreateClientHotlineRequestInterviewSchedule = ({ json, path: { hotline_request_id, id } }, meta) => apiCreate(API_CREATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_CREATE, `/client/hotline/${id}/request/${hotline_request_id}/schedule`, json, meta);
/**
 * クライアント：ホットライン相談申し込み面談 キャンセル（新規作成）
 */
export const apiCreateClientHotlineRequestInterviewCancel = ({ json, path: { hotline_request_id, id } }, meta) => apiCreate(API_CREATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_CANCEL, `/client/hotline/${id}/request/${hotline_request_id}/cancel`, json, meta);
/**
 * クライアント：ホットライン相談申し込み面談 もう一度相談を申し込む
 */
export const apiCreateClientHotlineRequestInterviewReorder = ({ json, path: { hotline_request_id, id } }, meta) => apiCreate(API_CREATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_REORDER, `/client/hotline/${id}/request/${hotline_request_id}/reorder`, json, meta);
